<template>
  <div class="mb-24">
    <div class="heading-2">{{ i18n(translations.title) }}</div>
    <div>
      {{ i18n(translations.description) }}
    </div>
  </div>

  <NavTabs
    :index-route-name="ROUTE_NAMES.INVOICES.PAST_INVOICES.INDEX"
    :label="translations.pastInvoicesNavigation"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './PastInvoices.translations'

const i18n = useI18n()
</script>
